import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	rolledUpEstimateToolip: {
		id: 'portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.rolled-up-estimate-toolip',
		defaultMessage: 'Rolled-up value: {value}',
		description: 'Tooltip text for the rolled up estimate value',
	},
});
